import React, {useState, useEffect, useRef} from 'react';
// import { useDispatch } from 'react-redux';
import {useLocation} from 'react-router-dom';
import {
  Button,
  Card,
  CardGroup,
  Col,
  Container,
  Form,
  InputGroup,
  Row
} from 'react-bootstrap';
// import '../../assets/css/pages/form.css';
import {LoaderMedium} from './../../components/loader';
import ValidationHelper from '../../helper/validation';
//Axios Call
// import {reset_password} from '../../actions/action-creators/auth';
import {error_api_call,
        post_api_call_main
} from '../../actions/action-creators/common';
// import {post_api_call,
//         get_api_call_main,
//       } from './../../actions/action-creators/common';
import {SetMetaData} from './../../helper/page-title';
import { alertResponseMessage } from '../../actions/action-creators/response';

const ResetPassword = () => {
  SetMetaData("Reset Password", "", "");
  const location = useLocation();
  const isMounted = useRef(null);
  const [currentStep, setCurrentStep] = useState(1);//1=>Submit Mobile Number,2=>Reset Password
  const [isSuccess, setIsSuccess] = useState(false);
  //Store Data
  // const authReduxData = useSelector(state => state.auth);
  // const dispatch = useDispatch()
  //State
  const inputDefaultValue = {
    password: '',
    email: '',
    otp: '',
    ref_id: ''
  };
  const [inputFields, setFields] = useState(inputDefaultValue);
  const [secureOtp, setsecureOtp] = useState({otp: true, password: true});
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [isLoginProcess, setIsLoginProcess] = useState(false);
  const [isError, setIsError] = useState('');
  const [redirectUri, setRedirectUri] = useState('');
  //Redirection Url
  useEffect(() => {
    const urlHandling = () => {
      try{
        // const urlQuryString = window.location.search;
        const urlQuryString = location.search;
        const urlParam = new URLSearchParams(urlQuryString);
        const urlRedirect = urlParam.get('redirect_uri');
        const urlEmail = urlParam.get('email');
        if(urlEmail){
          setFields({...inputFields, email: urlEmail});
        }
        if(urlRedirect !== '' && urlRedirect !== null){
          setRedirectUri(urlRedirect);
        }
      }catch(e){
        error_api_call({error: `auth/reset-password|urlHandling|${e}`});
      }
    }
    urlHandling();
  }, []);// eslint-disable-line react-hooks/exhaustive-deps
  //Update Input Box
  const _onChangeText = (attrName, value) => {
    try{
      setIsError('');
      let fields = {...inputFields};
      if(attrName === 'otp'){
        value = value.replace(/[^0-9]/g, '');
      }else{
        value = value.replace(/ /g, '');
      }
      fields[attrName] = value;
      setFields({...fields});
    }catch(e){
      error_api_call({error: `auth/reset-password|_onChangeText|${JSON.stringify(inputFields)}|${e}`});
    }
  }
  //Input Validation:Use to Toggle Button: Disable-true|false
  useEffect(()=>{
    //Validate Input
    const _validate = () => {
      // if (!didMount) return null;
      let fields = {...inputFields};
      try{
        var validators = {email: 'required|email|max:150'};
        var validation = [];
        if(currentStep !== 1){
          validators['password'] = 'required|password|min:8|max:15';
          validators['otp'] = 'required|digit|min:4|max:4|Verification Code';
        }
        validation = ValidationHelper.validation(fields, validators).error;
        setSubmitDisabled(validation.length ? true : false);
        return validation.length ? false : true;
      }catch(e){
        error_api_call({error: `auth/reset-password|_validate|${JSON.stringify(inputFields)}|${e}`});
      }
    };
    _validate();
    isMounted.current = true;
    return () => {
      // executed when unmount
      isMounted.current = false;
    }
  }, [inputFields]);// eslint-disable-line react-hooks/exhaustive-deps
  //Toggle Show-Hide Password
  const _showHideOtp = (field) => {
    setsecureOtp({...secureOtp, [field]: !secureOtp[field]})
  };
  //Reset Password
  const _resetPassword = async(e) => {
    e.preventDefault();
    //Validation:Already done
    //Show Loader
    try{
      setIsError('');
      const formData = {...inputFields};
      if(currentStep === 1){
        //Send Verfication Code
        setCurrentStep(2);
        setSubmitDisabled(true);
        const apiCode = await post_api_call_main(`reset-password/user-check`, {email: formData.email, fetch_type: 2}, false);
        if(apiCode.status === 200){
          setFields({...inputFields, ref_id: apiCode.ref_id});
        }
      }else{//Reset Password
        setIsLoginProcess(true);
        const cb_reset = await post_api_call_main(`reset-password`, {...formData, fetch_type: 2});
        // dispatch(reset_password('reset-password', formData, cb_reset => {
          // if (isMounted.current) {
            if(cb_reset.status === 200){
              setIsSuccess(true);
              alertResponseMessage({alert_type: 1, message: `Password updated Successfully! Please login. Redirecting...`});
              setTimeout(() => {
                window.location.href = redirectUri
                  ? `/login?redirect_uri=${redirectUri}&email=${formData.email}`
                  : `/login?email=${formData.email}`;
              }, 5000);
            }else{
              setIsError(cb_reset.message);
              setIsLoginProcess(false);
            }
          // }
        // }));
      }
    }catch(e){
      console.log(e)
      setIsError('Error Updating Password ! Please Try Again');
      setIsLoginProcess(false);
      error_api_call({error: `auth/reset-password|_resetPassword|${JSON.stringify(inputFields)}|${e}`});
    }
  }
  //Forget Password Redirect
  const _loginPageRedirection = (e) => {
    e.preventDefault();
    if(redirectUri){
      window.location.href = `/login?redirect_uri=${redirectUri}&email=${inputFields.email}`;
    }else{
      window.location.href = `/login?email=${inputFields.email}`;
    }
  }

  return (
    <main id="main">
        <div className="align-items-center login-form content-wrapper">
        <Container style={{minHeight: '87vh'}}>
            <Row className="justify-content-center">
            <Col md="7" lg="4">
                <CardGroup>
                <Card className="p-2 pt-0">
                    <Card.Body className="p-4">
                    <form name="login" id="login">
                        <div className="text-center">
                            <img src={require("../../assets/images/logo/logo.jpg")} alt="Logo" className="img-fluid w-200p mb-3" />
                        </div>
                        <div className="mb-4">
                            <h1 className="text-center">Reset Password</h1>
                        </div>
                        {/* <p className="text-muted text-center">Sign In to your account</p> */}
                        {isSuccess
                        ?
                          <Row className='mt-5'>
                            <Col xs="12" className="text-center">
                                <div className="alert alert-success" role="alert">
                                  Password updated Successfully! Please login. Redirecting to login page...
                                </div>
                            </Col>
                          </Row>
                        :
                        <>
                          {/* Email */}
                          <div className="mb-3">
                              <InputGroup>
                                  <InputGroup.Text><i className="mdi mdi-18px mdi-email"></i><em>*</em></InputGroup.Text>
                                  <Form.Control 
                                      type="email" 
                                      placeholder="Email"
                                      autoComplete="user_name" 
                                      value={inputFields.email}
                                      onChange={(event) => _onChangeText('email', event.target.value)}
                                      maxLength={100}
                                      //   readOnly={currentStep !== 1 || isLoginProcess ? true : false}
                                      // readOnly={isLoginProcess ? true : false}
                                      readOnly={currentStep !== 1 ? true : false}
                                  />
                              </InputGroup>
                              {/* <p className="input-info">Space Not Allowed</p> */}
                              {currentStep !== 1 && (
                              <a
                                href="#"
                                onClick={(e) => {e.preventDefault(); setCurrentStep(1); setIsError('');}}
                                className="clearfix float-end mt-1 mb-2 link-info"
                              >Change</a>)}
                              {/* <p className="clearfix float-end mt-1 mb-2 link-info">Change</p> */}
                          </div>
                          <p className="mt-4">We’ll send a verification code to this email if it matches an existing account.</p>
                          {currentStep > 1 &&
                          <>
                              <div className="mb-3">
                              <InputGroup>
                                  <InputGroup.Text><i className="mdi mdi-lock"></i><em>*</em></InputGroup.Text>
                                  <Form.Control 
                                  type={secureOtp.otp ? "password" : "text"}
                                  placeholder="Verification Code" 
                                  autoComplete="current-otp" 
                                  value={inputFields.otp}
                                  onChange={(event) => _onChangeText('otp', event.target.value)}
                                  maxLength={6}
                                  readOnly={isLoginProcess ? true : false}
                                  />
                                  {inputFields.otp !== "" &&
                                  <i className={`mdi icon-eye ms-3 ${secureOtp.otp ? 'mdi-eye' : 'mdi-eye-off'}`} onClick={() => _showHideOtp('otp')}></i>
                                  }
                              </InputGroup>
                              <p className="input-info">Verification Code Sent is valid for only 15 Minutes</p>
                              </div>
                              <div className="mb-3">
                              <InputGroup>
                                  <InputGroup.Text><i className="mdi mdi-lock"></i><em>*</em></InputGroup.Text>
                                  <Form.Control 
                                  type={secureOtp.password ? "password" : "text"}
                                  placeholder="Password" 
                                  autoComplete="current-password" 
                                  value={inputFields.password}
                                  onChange={(event) => _onChangeText('password', event.target.value)}
                                  maxLength={15}
                                  readOnly={isLoginProcess ? true : false}
                                  />
                                  {inputFields.password !== "" &&
                                  <i className={`mdi icon-eye ms-3 ${secureOtp.password ? 'mdi-eye' : 'mdi-eye-off'}`} onClick={() => _showHideOtp('password')}></i>
                                  }
                              </InputGroup>
                              <p className="input-info">Minimum 8 Characters, Maximum 15 Characters</p>
                              </div>
                              
                          </>
                          }
                          <Row className='mt-5'>
                          {isError &&
                            (<Col xs="12" className="text-center">
                                <div className="alert alert-danger" role="alert">
                                    {isError}
                                </div>
                            </Col>)
                            }
                          <Col xs="12" className="text-center">
                              {isLoginProcess ? 
                              <Button
                                  title="Submit"
                                  disabled={true}
                                  color={'primary'}
                                  className="bg-color-blue fs-6"
                              >
                                  <LoaderMedium width={20} />
                                  {currentStep === 2
                                  ? 'Updating...'
                                  : 'Submiting...'
                                  }
                              </Button>
                              : 
                              <Button
                                  type="submit"
                                  disabled={submitDisabled}
                                  onClick={(e) => _resetPassword(e)}
                                  color={"primary"}
                                  className="px-4 bg-color-blue fs-6"
                              >{currentStep === 2
                                  ? 'Update Password'
                                  : 'Submit'
                                  }</Button>
                              }
                          </Col>
                          {currentStep === 1 &&
                            <Col xs="12" className="text-right mt-4">
                              <p className="link mb-0 text-center">
                                <button
                                    className='btn p-0 link-custom link-info'
                                    onClick={(e) => _loginPageRedirection(e)}
                                    disabled={false}
                                    >Back to Login Page</button>
                              </p>
                            </Col>
                          }
                          {/* If you don’t see the email in your inbox, check your spam folder. If it’s not there, the email address may not be confirmed, or it may not match an existing LinkedIn account. */}
                          {/* <Col xs="12" className="text-center">
                                  <Link to="/register">
                                      <p className="link link-highlight">Don`t have acoount? Create one, click here</p>
                                  </Link>
                          </Col> */}
                          </Row>
                        </>
                        }
                    </form>
                    </Card.Body>
                </Card>
                </CardGroup>
            </Col>
            </Row>
        </Container>
        </div>
    </main>
  )
}

export default ResetPassword